export default {
  mutations: {
    SET_BANK_ACCOUNT_TYPES_LIST: 'SET_BANK_ACCOUNT_TYPES_LIST',
  },
  getters: {
    GET_BANK_ACCOUNT_TYPES_LIST: 'GET_BANK_ACCOUNT_TYPES_LIST',
  },
  actions: {
    BANK_ACCOUNT_TYPES_LIST: 'BANK_ACCOUNT_TYPES_LIST',
  },
};
